import * as types from '../constants/actionTypes';
import initialState from './initialState';
import Immutable from 'seamless-immutable';

/* Note */
/* Params: isLoadMore to check user have load more yet */
export default function hiddenListReducer(state = initialState.hiddenList, action) {
  switch (action.type) {
    case types.UPDATE_HIDDEN_LIST_STATE: {
      return state.merge({ ...action.data });
    }
    case types.GET_HIDDEN_LIST_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      let updateParams = {};
      updateParams = {
        isLoading: false,
        isCalled: true,
        data: action.params && action.params.isLoadMore ? [...data, ...action.data] : action.data,
        isHasMore: !(action.data instanceof Array && action.data.length < (action.params.pageSize || 25)),
        page: action.params.page,
        isCallingLoadMore: false,
      };
      return state.merge({ ...updateParams });
    }
    case types.DELETE_HIDDEN_LIST_SUCCESS: {
      const { data } = Immutable.asMutable(state);
      const update = data.filter(item => item.user.userId !== action.userId);
      return state.merge({ data: update });
    }
    case types.USER_LOGOUT_SUCCESS: {
      const reset = {
        data: [],
        page: 1,
        isLoading: false,
        isHasMore: true,
      };
      return state.merge({
        ...reset,
      });
    }
    case types.DELETE_ALL_PROFILE_HIDDEN_SUCCESS: {
      return state.merge({
        data: [],
      });
    }

    default:
      return state;
  }
}
